import { ReactNode } from "react";
import { RegistrationSectionStatus } from "./getRegistrationState";
import { cn } from "cy-fe/src/utils/cn";
import { HeaderText } from "../components/HeaderText";
import { LinkButton } from "cy-fe";
import { CircleCheckBigIcon, CircleIcon } from "lucide-react";

export interface RegistrationSectionProps {
  status?: RegistrationSectionStatus;
  className?: string;
  header: ReactNode;
  subheader: ReactNode;
  disabled?: boolean;
  href?: string;
}
export function RegistrationSection({
  className,
  status,
  header,
  subheader,
  disabled,
  href,
}: RegistrationSectionProps) {
  return (
    <div
      className={cn(
        "flex flex-wrap gap-5 rounded bg-gray-100 p-5 sm:flex-nowrap",
        className,
      )}
    >
      <div className="flex flex-grow items-center gap-8">
        <div className="flex max-w-[6rem] flex-grow items-center">
          <CompleteIndicator status={status} />
        </div>
        <div className="w-fit">
          <HeaderText vStyle="h2">{header}</HeaderText>
          <p className="text-sm sm:text-base">{subheader}</p>
        </div>
      </div>
      {status === "incomplete" && (
        <div className="flex w-full items-center justify-end sm:w-[8rem]">
          <LinkButton className={cn("w-full")} href={href} disabled={disabled}>
            {disabled ? "Unavailable" : "Complete"}
          </LinkButton>
        </div>
      )}
    </div>
  );
}
export interface CompleteIndicatorProps {
  className?: string;
  status?: RegistrationSectionStatus;
}
export function CompleteIndicator({
  status,
  className,
}: CompleteIndicatorProps) {
  return (
    <div
      className={cn(
        "flex h-14 w-14 items-center justify-center rounded-full",
        status === "incomplete" && "bg-gray-400",
        status === "complete" && "bg-green-400",
        className,
      )}
    >
      {status === "complete" && <CircleCheckBigIcon className="text-white" />}
      {status === "incomplete" && <CircleIcon className="text-white" />}
    </div>
  );
}
